import { TAccountCard } from './Card';
import { TWalletData } from './WalletData';
import {
  TGetTransactionDetailsData,
  TransactionTypes,
  TransactionData
} from '@/services/types/TransactionData';

export type TTransactionHistory = {
  wallet?: TWalletData;
  card?: TAccountCard;
  details?: TGetTransactionDetailsData;
  type: TransactionTypes;
  data: TransactionData;
  toWallet?: TWalletData;
};

export const SortDirectionEnum = {
  ASC: 'asc',
  DESC: 'desc'
} as const;
